// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Core__Int = require("@rescript/core/src/Core__Int.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.bs.js");

function bool(params, key) {
  var match = params.get(key);
  if (match == null) {
    return ;
  }
  switch (match) {
    case "false" :
        return false;
    case "true" :
        return true;
    default:
      return ;
  }
}

function stringArrNonEmpty(params, key) {
  var v = params.getAll(key);
  if (v.length !== 0) {
    return v;
  }
  
}

function $$int(params, key) {
  return Core__Option.flatMap(Caml_option.nullable_to_opt(params.get(key)), (function (v) {
                return Core__Int.fromString(v, undefined);
              }));
}

function string(prim0, prim1) {
  return Caml_option.nullable_to_opt(prim0.get(prim1));
}

function setIfExists(searchParams, key, v, toString) {
  if (v !== undefined) {
    searchParams.set(key, toString(Caml_option.valFromOption(v)));
  } else {
    searchParams.delete(key);
  }
}

function setIfExistsInt(none, none$1, none$2) {
  return setIfExists(none, none$1, none$2, (function (v) {
                return v.toString();
              }));
}

function setIfExistsBool(none, none$1, none$2) {
  return setIfExists(none, none$1, none$2, (function (v) {
                if (v) {
                  return "true";
                } else {
                  return "false";
                }
              }));
}

function setIfExistsArr(searchParams, key, v, toString) {
  if (v !== undefined) {
    v.forEach(function (c) {
          searchParams.append(key, toString(c));
        });
  } else {
    searchParams.delete(key);
  }
}

function setIfExistsArrStr(none, none$1, none$2) {
  return setIfExistsArr(none, none$1, none$2, (function (v) {
                return v;
              }));
}

function setQueryParamsInURL(paramsToUrl, toParams, fromUrl, modeOpt, updater) {
  var mode = modeOpt !== undefined ? modeOpt : "replace";
  var $$location = window.location;
  var newUrl = paramsToUrl(updater(toParams(fromUrl(new URLSearchParams($$location.search)))));
  if (mode === "replace") {
    return RescriptReactRouter.replace(newUrl);
  } else {
    return RescriptReactRouter.push(newUrl);
  }
}

function use(fromUrl, toParams, setQueryParamsInURL) {
  var params = toParams(fromUrl(new URLSearchParams(RescriptReactRouter.useUrl(undefined, undefined).search)));
  return [
          params,
          setQueryParamsInURL
        ];
}

function getCurrentParams(fromUrl, toParams) {
  var $$location = window.location;
  return toParams(fromUrl(new URLSearchParams($$location.search)));
}

var URLHelpers = {
  setQueryParamsInURL: setQueryParamsInURL,
  use: use,
  getCurrentParams: getCurrentParams
};

exports.bool = bool;
exports.stringArrNonEmpty = stringArrNonEmpty;
exports.$$int = $$int;
exports.string = string;
exports.setIfExists = setIfExists;
exports.setIfExistsInt = setIfExistsInt;
exports.setIfExistsBool = setIfExistsBool;
exports.setIfExistsArr = setIfExistsArr;
exports.setIfExistsArrStr = setIfExistsArrStr;
exports.URLHelpers = URLHelpers;
/* RescriptReactRouter Not a pure module */
